import React from 'react';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Input } from 'semantic-ui-react';
import Server from '../../../functions/server';
import Loading from '../../loadings';
import $ from "jquery";
import Button from '@material-ui/core/Button';

class Upload extends React.Component {

  state = {
    open: false,
    fullWidth: true,
    maxWidth: 'sm',
    maxWidth: 'xs',
    files: []
  }


  getFiles() {
    if (!this.props.menuPermission.add) {
      alert('You ARe Not Allow To Upload File!!!');
      return;
    }
    let context = this;
    let id = context.props.id;
    let invoiceno = context.props.invoiceno;
    context.setState({ open1: false, open: false })
    $.ajax({
      type: 'POST',
      data: { 'id': context.props.id },
      url: Server()+'expensedetail/getfiles.php',
      success: function(data) {
        context.setState({ load: false })
        try {
          data = JSON.parse(data);
          context.setState({ files: data, open: true })
        } catch (e) {
          alert('Error!!!')
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  deleteFile(id, source) {
    if (this.props.machinesalesedit == 'none') {
      alert('Access is Denied!!!');
      return;
    }
    let context = this;
    $.ajax({
      type: 'POST',
      data: { 'id': id, 'name': source },
      url: Server() + 'machinesales/deletefile.php',
      success: function(data)
      {
        if (data == 1) {
          context.getFiles();
        }
        else {
          alert('Error!!!');
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
        });
      }
    });
  }

  submit() {
    let context = this;
    let file = this.state.loadedfile;

    var formData = new FormData();
    formData.append('id', context.props.id);
    formData.append('fileName', context.state.fileName);
    formData.append('file', file);
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'expensedetail/uploadfile.php',
      success: function(data)
      {
        if (data == 1) {
          alert('Image Uploaded');
          context.getFiles();
        }
        else {
          alert('Image not upload');
        }
      },
      error: function(err)
      {
        context.setState({
          error: "Try again",
        });
      }
    });
  }

  changeHandle = name => event => { this.setState({ [name]: event.target.value }); };

  render() {
    let  i = 0;
    return (
      <div>
        { this.props.files > 0 ?
          (
            <CreateNewFolder style={{color: 'green', cursor: 'pointer'}}
              onClick={this.getFiles.bind(this)} />
          ):
          (
            <CreateNewFolder style={{color: 'red', cursor: 'pointer'}}
              onClick={this.getFiles.bind(this)} />
          )
        }
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open}   onClose={ () => { this.setState({ open: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Files</DialogTitle>
          <DialogContent style={{paddingLeft: '4%'}}>
            <DialogContentText>
              { this.state.files.map((x) => {
                  ++i;
                  return (
                    <div style={{padding: '1%', cursor: 'pointer', display: 'flex'}}>
                      <u style={{color: '#6CA1EE'}} onClick={ () => { window.open(x.file) } }>
                        {i+".  "+x.file_name}
                      </u>
                      <p style={{paddingLeft: '2%'}}>
                        
                      </p>
                    </div>
                  )
                })
              }
              Upload File<br/>
              <input type="file" name="fileToUpload" id="fileToUpload" onChange={(e) => { this.setState({ loadedfile: e.target.files[0], open1: true }) }}/>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ open: false }) }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth1}
          open={this.state.open1}   onClose={ () => { this.setState({ open1: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Files</DialogTitle>
          <DialogContent style={{paddingLeft: '4%'}}>
            <DialogContentText>
              File name
              <Input value={this.state.fileName} onChange={this.changeHandle('fileName')} />
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">
              Submit
            </Button>
            <Button onClick={ () => { this.setState({ open1: false }) }} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Upload;
